import React from 'react';

export default function Button({ 
  variant = 'primary', 
  children, 
  onClick, 
  href, 
  target,
  rel,
  className = '',
  ...props 
}) {
  const baseStyles = 'inline-flex items-center justify-center gap-2.5 px-9 py-[18px] text-body-s font-medium rounded-pill transition-all duration-300 ease-out';
  
  const variants = {
    primary: 'bg-warm-black text-cream hover:bg-gold hover:text-warm-black hover:-translate-y-0.5 hover:shadow-btn-gold',
    ghost: 'bg-transparent text-warm-black border-[1.5px] border-warm-black hover:bg-warm-black hover:text-cream',
    cream: 'bg-cream text-warm-black hover:bg-gold-light hover:scale-105',
    gold: 'bg-gold-bg text-warm-black hover:bg-gold-light hover:-translate-y-0.5',
    'gold-on-dark': 'bg-gold-bg text-warm-black hover:bg-gold-light hover:-translate-y-0.5',
  };
  
  const styles = `${baseStyles} ${variants[variant] || variants.primary} ${className}`;
  
  if (href) {
    return (
      <a href={href} className={styles} target={target} rel={rel} {...props}>
        {children}
      </a>
    );
  }
  
  return (
    <button onClick={onClick} className={styles} {...props}>
      {children}
    </button>
  );
}